import { installRequestDeduplication } from "./utils/http/requestDeduplication";

// Install global axios request de-duplication before any other module is
// evaluated. Imported as the very first statement in index.js so that even
// axios instances created at module-load time (`axios.create()`) inherit the
// de-duplicating adapter.
installRequestDeduplication();
